<template>
  <a-form-item
    :label="data.fieldname"
    :required="data.isneeded ? true : false"
    class="not-edit-item clearfix"
  >
    <div
      v-if="$toType(value) === 'array'"
      :class="data.fieldtype + '-box'"
      class="arr"
    >
      <template v-if="data.fieldtype === 'tag'">
        <span
          v-for="(tag, i) in value"
          :key="i"
          class="tag"
        >{{ tag }}</span>
      </template>
      <template v-else-if="data.fieldtype === 'file'">
        <a
          v-for="(file, i) in value"
          :key="i"
          class="file"
          @click="handleclickGallery(value, i)"
        >{{ file.file_name }}</a>
      </template>
      <!-- 审核详情--接待方式-不可编辑-返回的是数组 -->
      <template v-else-if="data.fieldtype === 'select_reception'">
        <span>{{ value.length > 0 ? value.join('/') : '- -' }}</span>
        <a
          v-if="data.isedit"
          class="edit-btn fs-blue"
          @click="handleEdit"
        >{{ $t('message["1388"]') }}</a>
      </template>
      <template v-else>
        <span>{{ value.join(',') }}</span>
      </template>
    </div>
    <div
      v-else-if="$toType(value) === 'object'"
      :class="data.fieldtype + '-box'"
    >
      <template v-if="data.fieldtype === 'select_tree'">
        <span
          v-if="!Object.keys(value).length || value.input === '' && !value.treedata.length"
          class="tree-input"
        >
          - -
        </span>
        <span
          v-if="value.input"
          class="tree-input"
        >
          {{ value.input }}
        </span>
        <span
          v-for="(tag, i) in value.treedata"
          :key="i"
          class="tag"
        >{{ tag }}</span>
        <!-- <span v-if="!value.input && value.treedata && !value.treedata.length">- -</span> -->
      </template>
      <template v-else-if="data.fieldtype === 'area'">
        <div v-if="!value.code && !value.address">
          - -
        </div>
        <div v-else>
          <span
            v-if="value.code && Object.values(value.code).length"
            class="code"
          >{{ Object.values(value.code).join('/') }}</span>
          <span class="address">{{ value.address }}</span>
        </div>
      </template>
    </div>
    <div
      v-else-if="$toType(value) === 'string' || value === null"
      :class="`${data.fieldtype}-box`"
    >
      <div
        v-if="data.fieldtype === 'editor'"
        class="editor quill-editor"
        :class="{'empt': value === '- -'}"
      >
        <div
          class="html ql-editor"
          v-html="$filterXss.process(value)"
        />
      </div>
      <!-- 审核详情--接待方式-不可编辑-返回的是字符串 -->
      <template v-else-if="data.fieldtype === 'select_reception'">
        {{ value }}
      </template>
      <div
        v-else
        class="text-value"
      >
        {{ value }}
      </div>
    </div>
  </a-form-item>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      value: ''
    }
  },
  watch: {
    data: {
      handler (val) {
        this.setItem()
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.setItem()
  },
  methods: {
    setItem () {
      // console.log(this.data.fieldtype)
      // valuenames 是通过的询盘详情，接待方式自定义的属性名
      let { fieldtype = '', fieldvalue, valuenames, fieldvaluedesc, options = [], fieldconfig = {} } = this.data
      switch (fieldtype) {
        case 'string':
        case 'text':
        case 'number':
        case 'ip':
        case 'datetime':
        case 'editor':
          this.value = fieldvalue || '- -'
          break
        case 'phone':
        case 'email':
        case 'tag':
          this.value = fieldvalue || []

          if (!this.value.length) {
            this.value = '- - '
          }
          break
        case 'file':
          fieldvalue.map(item => {
            item.description = item.file_name
            item.href = item.file_url
            item.title = this.$t('message["1304"]')

            return item
          })
          this.value = fieldvalue || []
          // console.log(this.value)
          if (!this.value.length) {
            this.value = '- - '
          }
          break
        case 'select':
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_type':
        case 'radioinfo_followup':
          if (options && this.$toType(options) === 'object') {
            options = _.reduce(options, (res, item) => {
              res.push(item)
              return res
            }, [])
          }
          this.value = this.optionGetValue(fieldvalue, options)
          break
        case 'radioinfo_level':
          const { type } = fieldconfig

          if (fieldvalue === '') {
            this.value = '- -'
            break
          }

          if (type === 1) {
            options = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
          } else if (type === 2) {
            options = this.$t('message["1444"]').split(',')
          }
          options.forEach((item, index) => {
            if (fieldvalue - 1 === index) {
              this.value = item || '- -'
            }
          })
          break
        case 'checkbox':
          this.value = this.optionGetValues(fieldvalue, options)
          break
        case 'select_tree':
          this.value = fieldvaluedesc || {}
          break
        case 'area':
          this.value = fieldvalue || {}
          break
        case 'select_reception':
          this.value = valuenames || fieldvalue || '- -'
          break
        default:
          this.value = fieldvalue || '- -'
          break
      }
    },

    optionGetValue (value, options) {
      if (!options || !options.length) return '- -'

      const filter = options.filter(item => item.id * 1 === value * 1)
      return (filter[0] && filter[0].name) || '- -'
    },
    optionGetValues (values, options) {
      if (!options || !options.length) return '- -'

      const filter = options.filter(item => {
        for (let value of values) {
          if (item.id * 1 === value * 1) {
            return item
          }
        }
      })
      return filter.map(item => item.name)
    },
    handleclickGallery (fileList, i) {
      let item = fileList[i]
      if (item.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            // window.open(item.url || item.file_url)
            this.$downloadFile(item.url || item.file_url)
          }
        })
      } else {
        this.$bus.$emit('getFileGallery', fileList, i)
      }
    },
    handleEdit () {
      this.$emit('handleEdit')
    }
  }
}
</script>

<style lang="scss" scoped>
.tag {
  display: inline-block;
  margin-right: 16px;
  padding: 2px 4px;
  line-height: 1.2;
  font-size: 12px;
  color: $gray2;
  border: solid 1px $gray4;
  border-radius: 4px;
}
.area-box .code {
  margin-right: 16px;
}
.tree-input {
  margin-right: 16px;
}
.editor-box ::v-deep {
  .editor {
    border-radius: 4px;
    border: solid 1px #d6d6d6;
    .html {
      max-height: 300px;
      padding: 8px 12px;
      word-break: break-all;
      overflow-y: scroll;
    }
    img {
      display: inline-block;
      max-width: 100%;
    }
  }
  .empt {
    padding: 0;
    border: none;
    .ql-editor {
      padding: 0;
    }
  }
  ul li {
    list-style: initial;
  }
  img {
    display: inline-block;
    max-width: 100%;
  }
}
.file-box ::v-deep {
  a {
    display: block;
    max-width: 400px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.text-box {
  .text-value {
    max-width: 898px;
    word-break: break-all;
  }
}
</style>
